﻿import { useQuery } from 'react-query';

import StageService from 'services/stage.service';

export function useGetStages(params, options) {
  return useQuery(['stages', params], () => StageService.get(params), options);
}
